import React from 'react';
import {Tooltip, TooltipProps} from '@mui/material';

function CVATTooltip(props: TooltipProps): JSX.Element {
    const { children, ...rest } = props;

    return (
        <Tooltip {...rest}>
            {children}
        </Tooltip>
    );
}

export default React.memo(CVATTooltip);
